import { Country } from '../../model'
import { useConsumerSelector } from '../../state'
import { app } from '../../env'
import { useRouter } from 'next/router'
import { mapLocales } from '../../utils/mapLocales'
import { useIsCashTheme } from '@afterpaytouch/core'
import { SupportedLocale } from '@afterpay/types'

interface AmplitudeCustomUserProperties {
  country: Country
  consumerId: number
  locale: SupportedLocale
  activeExperiment: string
  isNewPortalEnabled: boolean
}

interface AmplitudeEnduringEventProperties {
  activeExperiment: string
  category: string
  consumerRedesign: boolean
  appEnvironment: string
  appVersion: string
  isCashTheme: boolean
}

export function useUserProperties(): AmplitudeCustomUserProperties {
  const { id } = useConsumerSelector()
  const router = useRouter()
  const locale = router.locale as SupportedLocale
  return {
    consumerId: id,
    locale,
    country: mapLocales('locale', locale) as Country,
    activeExperiment: '',
    isNewPortalEnabled: true,
  }
}

export function useEnduringEventProperties(): AmplitudeEnduringEventProperties {
  const isCashTheme = useIsCashTheme()
  const { APP_ENVIRONMENT, APP_VERSION } = app
  return {
    activeExperiment: '',
    appEnvironment: APP_ENVIRONMENT,
    appVersion: APP_VERSION,
    category: 'Consumer',
    consumerRedesign: true,
    isCashTheme,
  }
}
